const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/ECheckinForm.tsx';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import PersAngaben from 'App/config/triemli/eCheckin/sections/PersAngaben';
import Wohnsitz from 'App/config/triemli/eCheckin/sections/Wohnsitz';
import Arzt from 'App/config/triemli/eCheckin/sections/Arzt';
import Versicherung from 'App/config/triemli/eCheckin/sections/Versicherung';
import KontaktPerson from 'App/config/triemli/eCheckin/sections/KontaktPerson';
import textMap from 'App/config/triemli/eCheckin/translations';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), [formId]);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <Wohnsitz path="wohnsitz" title={textMap.wohnsitz} />
            <Arzt path="einwArzt" title={textMap.einwArzt} />
            <KontaktPerson path="kontakt" title={textMap.kontakt} />
            <Versicherung path="versicherung" title={textMap.versicherungLabel} />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
